import { ottehrExtensionUrl, ottehrValueSetUrl } from '../../fhir/systemUrls';

export const PROCEDURE_TYPES_VALUE_SET_URL = ottehrValueSetUrl('procedure-type');
export const MEDICATIONS_USED_VALUE_SET_URL = ottehrValueSetUrl('procedure-medications-used');
export const BODY_SITES_VALUE_SET_URL = ottehrValueSetUrl('procedure-body-sites');
export const BODY_SIDES_VALUE_SET_URL = ottehrValueSetUrl('procedure-body-sides');
export const TECHNIQUES_VALUE_SET_URL = ottehrValueSetUrl('procedure-techniques');
export const SUPPLIES_VALUE_SET_URL = ottehrValueSetUrl('procedure-supplies');
export const COMPLICATIONS_VALUE_SET_URL = ottehrValueSetUrl('procedure-complications');
export const PATIENT_RESPONSES_VALUE_SET_URL = ottehrValueSetUrl('procedure-patient-responses');
export const POST_PROCEDURE_INSTRUCTIONS_VALUE_SET_URL = ottehrValueSetUrl('procedure-post-instructions');
export const TIME_SPENT_VALUE_SET_URL = ottehrValueSetUrl('procedure-time-spent');
export const PROCEDURE_TYPE_CPT_EXTENSION_URL = ottehrExtensionUrl('procedure-type-cpt');
export const PROCEDURE_TYPE_HCPCS_EXTENSION_URL = ottehrExtensionUrl('procedure-type-hcpcs');
